import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";

export function Layout({ children, hideFooter }) {
  return (
    <div className="App">
      <SiteHeader />
      <main className="relative">{children}</main>
      {!hideFooter && <SiteFooter />}
    </div>
  );
}
